import classNames from 'classnames/bind';
import styles from './Dashboard.module.scss';
import { Box } from '@mui/material';
import StatsChart from './components/StatsChart';
import DealOverviewChart from './components/DealOverviewChart';
import ProjectOverviewChart from './components/ProjectOverviewChart';
import MyTasks from './components/ProjectRevenue';

const cx = classNames.bind(styles);

const Dashboard = () => {
  return <>
  <Box className={cx('dashboard-container')}>
    <StatsChart />
      <Box display="flex" width="100%" className="my-8">
        <Box flex={2.5} mr={2} height="100%" sx={{
          maxWidth:"calc(100% - 420px)"
        }} className={cx('deal-overview-wrapper')}>
          <DealOverviewChart />
        </Box>
        <Box flex={1} minWidth={400}>
          <ProjectOverviewChart />
        </Box>
      </Box>
      <MyTasks /> 
    </Box>
    </>;
};

export default Dashboard;
